<!-- 积分抽奖页面配置 -->
<template>
  <div class='content'>
    <div class="mb-20">
      <el-button size="small" type="primary" @click="title='新增';resetForm();dialogVisible=true">新增</el-button>
    </div>
    <el-table 
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <el-table-column label="入口名称" prop="tabName"></el-table-column>
      <el-table-column label="排序" prop="tabOrder"></el-table-column>
      <el-table-column label="关联活动" prop="">
        <template slot-scope="scope">{{ scope.row.activity.activityName }}</template>
      </el-table-column>
      <el-table-column label="状态" prop="isDeleted">
        <template slot-scope="scope">
          <span v-if="scope.row.isDeleted==0">启用</span>
          <span v-if="scope.row.isDeleted==1">禁用</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            size="small" 
            @click="editActivity(scope.row)">编辑</el-button>
          <el-button 
            type="text" 
            size="small" 
            @click="updateStatus(scope.row)">{{ scope.row.isDeleted==1?'启用':'禁用' }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑游戏 -->
    <el-dialog :title="title" top="20px" :visible.sync="dialogVisible"> 
      <el-form :model="form" ref="form" :rules="rules" label-width="auto">
        <el-form-item label="页面名称：" prop="tabName">
          <el-input type="text" v-model="form.tabName" placeholder="请输入页面名称"></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="tabOrder">
          <el-input type="text" v-model="form.tabOrder" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="关联活动：" prop="activityId">
          <el-select v-model="form.activityId">
            <el-option v-for="i in activityList" :key="i.activityId" :value="i.activityId" :label="i.activityName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态：" prop="isDeleted">
          <el-radio-group v-model="form.isDeleted">
            <el-radio :label="0">启用</el-radio>
            <el-radio :label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetForm();title='';dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirm()">确定</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
 
<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
 
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    //ComponentName和文件名保持一致
    name:'pointsLotteryPage',
    data() {
      //这里存放数据
      return {
        tableData: [],
        total: 0,
        title: '',
        dialogVisible: false,
        buttonLoading: false,
        form: {
          tabId: null,
          activityId: '',
          tabName: '',
          tabOrder: '',
          isDeleted: ''
        },
        rules: {
          tabName: [{ required: true, message: '请输入页面名称', trigger: 'blur' }],
          tabOrder: [{ required: true, message: '请输入排序', trigger: 'blur' }],
          activityId: [{ required: true, message: '请选择活动', trigger: 'change' }],
          isDeleted: [{ required: true, message: '请选择状态', trigger: 'change' }]
        },
        activityList: []
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      /**获取列表数据 */
      getTableList(){
        this.ajax.fetch({
          url: this.apis.pointsLotteryPage.get,
          disableLoading: true,
          method: 'post',
          param: {},
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      getActivityList(){
        this.ajax.fetch({
          url: this.apis.lotteryActivity.get,
          disableLoading: true,
          method: 'post',
          param: {pageNum: 1, pageSize: 999},
          successFunc: res=>{
            this.activityList = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      editActivity(row){
        this.title = '编辑';
        this.form.tabId = row.tabId;
        this.form.activityId = row.activity.activityId;
        this.form.tabName = row.tabName;
        this.form.tabOrder = row.tabOrder;
        this.form.isDeleted = row.isDeleted;
        this.dialogVisible = true;
      },
      confirm(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.form.tabId == null) {
              this.ajax.fetch({
                url: this.apis.pointsLotteryPage.add,
                disableLoading: true,
                method: 'post',
                param: this.form,
                successFunc: res=>{
                  this.$message.success('新增成功!');
                  this.dialogVisible = false;
                  this.resetForm();
                  this.getTableList();
                },
                errorFunc: err=>{
                  this.$message.error(err.info);
                }
              });
            }else{
              this.ajax.fetch({
                url: this.apis.pointsLotteryPage.update,
                disableLoading: true,
                method: 'post',
                param: this.form,
                successFunc: res=>{
                  this.$message.success('编辑成功!');
                  this.dialogVisible = false;
                  this.resetForm();
                  this.getTableList();
                },
                errorFunc: err=>{
                  this.$message.error(err.info);
                }
              });
            }
          }
        });
      },
      updateStatus(row){
        this.form.tabId = row.tabId;
        this.form.activityId = row.activity.activityId;
        this.form.tabName = row.tabName;
        this.form.tabOrder = row.tabOrder;
        this.form.isDeleted = row.isDeleted == 0?1:0;
        let txt = row.advPosition==1?'启用':'禁用';
        this.$confirm(`确定${txt}该项?`, `确认${txt}`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.ajax.fetch({
            url: this.apis.pointsLotteryPage.update,
            disableLoading: true,
            method: 'post',
            param: this.form,
            successFunc: res=>{
              this.$message({
                type: 'success',
                message: `${txt}成功!`
              });
              this.resetForm();
              this.getTableList();
            },
            errorFunc: err=>{
              console.log(err);
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: `已取消${txt}`
          });    
          this.resetForm();      
        });
      },
      resetForm(){
        this.form = {
          tabId: null,
          activityId: '',
          tabName: '',
          tabOrder: '',
          isDeleted: ''
        }
      }
    },
    beforeCreate() {}, //生命周期 - 创建之前
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    beforeMount() {}, //生命周期 - 挂载之前
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getTableList();
      this.getActivityList();
    },
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    deactivated() {}, //如果页面有keep-alive缓存功能，当组件被移除时，触发钩子函数deactivated
  }
</script>

<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/page/activityManage/pointsLotteryPage/pointsLotteryPage.vue